export const isIOSDevice = (): boolean => {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return false;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const userAgent: string = navigator.userAgent || navigator.vendor || (window as any).opera || '';

  const iOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as unknown as { MSStream?: unknown }).MSStream;

  // iPadOS 13+ reports a Mac user agent, so detect it via touch support.
  const iPadOSAsMac = /Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1;

  return iOS || iPadOSAsMac;
};
